"use client";

import { useEffect } from "react";
import { useNotify } from "@ui-kit";
import { registerTrpcErrorNotifier } from "@integration/trpc/error-notify-sink";

export const TrpcErrorNotifier = () => {
  const { notify } = useNotify();

  useEffect(() => {
    return registerTrpcErrorNotifier((message) => {
      notify({ msg: message, severity: "error" });
    });
  }, [notify]);

  return null;
};
